import type { QueuedRequest } from '../types';

export interface RequestQueue {
  readonly items: ReadonlyArray<QueuedRequest>;
}

export interface RequestQueueService {
  addToQueue: (request: QueuedRequest) => void;
  processQueue: (newToken: string, fetch: typeof window.fetch) => Promise<void>;
  clearQueue: VoidFunction;
  rejectAllQueue: (error: Error) => void
}

export const createRequestQueueService = (): RequestQueueService => {
  let items: QueuedRequest[] = []

  const addToQueue = (request: QueuedRequest) => {
    if (request.skip) return
    items.push(request)
  }

  const clearQueue = () => {
    items = []
  }

  const processQueue = async (newToken: string, fetch: typeof window.fetch) => {
    const promises = items.map(
      async ({ input, init, resolve, reject }) => {
        try {
          const headers = new Headers(init.headers || {});
          headers.set("Authorization", `Bearer ${newToken}`);
          const response = await fetch(input, { ...init, headers });
          resolve(response);
        } catch (error) {
          reject(error instanceof Error ? error : new Error(String(error)));
        }
      }
    );

    await Promise.allSettled(promises);
    clearQueue()
  }

  const rejectAllQueue = (error: Error) => {
    items.forEach(({ reject }) => reject(error));
    clearQueue()
  }

  return { addToQueue, processQueue, rejectAllQueue, clearQueue }
}